export interface ConnectMangopayServiceProvider {
  name: string;
  legal_person_type: LegalPersonType;
  email: string;
  company_number: string;
  headquarters_address: ConnectMangopayAddress;
  phone: string;
}

export enum LegalPersonType {
  Business = 'BUSINESS',
  Organization = 'ORGANIZATION',
  SoleTrader = 'SOLETRADER',
  Partnership = 'PARTNERSHIP',
}

export interface ConnectMangopayLegalRepresentative {
  first_name: string;
  last_name: string;
  birth_date?: Date;
  nationality_id: string;
  country_of_residence_id: string;
}

export interface ConnectMangopayBankAccount {
  iban: string;
  owner_name: string;
  owner_address: ConnectMangopayAddress;
}

export interface ConnectMangopayAddress {
  address: string;
  city: string;
  zip_code: string;
  country_id: string;
}
